import { type WorkspaceAgentSpacePhase } from '~/components/v2/components/workspace/workspace-agent-panel/components/entry/workspaceAgentSpaceMotion';

type WorkspaceAgentBarFreezeParams = {
  freezeBar: boolean;
  phase: WorkspaceAgentSpacePhase;
};

type WorkspaceAgentBarFreezeUpdateParams = WorkspaceAgentBarFreezeParams & {
  didSettle: boolean;
};

/**
 * Latch that keeps the selection-bar shell mounted after `phase` leaves `unified`, until hide
 * settle. Arming is the same render as show — a `useState` follow-up commit is too late for
 * Cypress Cloud Clear.
 */
export const getWorkspaceAgentBarFreeze = ({
  didSettle,
  freezeBar,
  phase,
}: WorkspaceAgentBarFreezeUpdateParams): boolean => {
  if (didSettle) {
    return phase === 'unified';
  }

  return phase === 'unified' || freezeBar;
};

export const getIsWorkspaceAgentBarDrawn = ({ freezeBar, phase }: WorkspaceAgentBarFreezeParams): boolean =>
  phase === 'unified' || freezeBar;

export const getIsWorkspaceAgentBarCollapsing = ({ freezeBar, phase }: WorkspaceAgentBarFreezeParams): boolean =>
  phase !== 'unified' && freezeBar;
